<template>
  <div>
	<div class="container">
		<div class="wrapper">
			<span class="login100-form-title p-b-26">
				ICE &#151; Login
			</span>
			<span class="login100-form-title p-b-48">
				<i class="zmdi zmdi-font"></i>
			</span>

			<div class="wrap-input100">
				<Input label="Benutzername" v-model="uid" ref="uid" @keyup.enter="login"></Input>
			</div>

			<div class="wrap-input100">
				<span class="btn-show-pass">
					<i class="zmdi zmdi-eye"></i>
				</span>
				<Input label="Password" type="password" v-model="pwd" ref="pwd" @keyup.enter="login"></Input>
			</div>

			<div class="container-login100-form-btn">
				<div class="wrap-login100-form-btn">
					<div class="login100-form-bgbtn"></div>
					<Button @click="login">Login</Button>
				</div>
			</div>

			<div style="margin-top:20px;padding:5px;background:#fcc;color:#f00;border:1px solid #f00;border-radius:3px;" v-if="errMsg !== ''">
				{{ errMsg}}
			</div>

		</div>
	</div>
  </div>
</template>

<script>
  import Input from '../atoms/Input.vue'
  import ApiComm from '../../apicomm.js'
  import axios from 'axios'
  
  export default {
    components: {
      Input
    },
    mixins: [ApiComm],
	data() {
		return {
			errMsg: '',
			uid: '',
			pwd: ''
		};
	},
    methods: {
      login: function () {
		if (this.uid !== '') {
			this.$setItem('login_uid', this.uid)
		}

		this.apiCall([{method: 'core/login', param: {uid: this.uid, pwd: this.pwd}, id: 7}], this.evalApiResponse)
      },
      evalApiResponse: function (resp) {
        var vm = this
        this.$_.forEach(resp, function (value) {
          if (value.hasOwnProperty('id')) {
            switch (value.id) {
              case 7: // 7 = Result from '.../login'
                if (value.hasOwnProperty('error')) {
					vm.errMsg = value.error.message
                } else {
                  if (value.hasOwnProperty('result') && value.result.hasOwnProperty('success') && value.result.success === true) {
					vm.errMsg = ''
					vm.uid = ''
					vm.pwd = ''
// console.log(value)
// console.log(value.result.user_id)
// console.log(value.result.is_admin)
					vm.$store.commit('login', {user_id: value.result.user_id, is_admin: value.result.is_admin})
					if (vm.$route.query.hasOwnProperty('redirect')) {
					  vm.$router.push({ path: vm.$route.query.redirect})
					} else {
					  vm.$router.push({ path: '/home'})
					}
                  }
                }
                break
            }
          }
        })
      }
	},
	mounted: function () {
		var t = this
		this.$getItem('login_uid').then((value) => {
			t.uid = value
			if (value !== null && value != '' && value != 'null') {
				t.$refs.pwd.$refs.inp.focus()
			} else {
				t.$refs.uid.$refs.inp.focus()
			}
		}).catch((err) => {
			t.$refs.uid.$refs.inp.focus()
		})
    }
  }
</script>

<style scoped="">

.container {
  width: 100%;  
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
}

.wrapper {
  width: 390px;
  background: #fff;
  border: 1px solid #aaa;
  border-radius: 6px;
  overflow: hidden;
  padding: 40px 55px 33px 55px;
}

.login100-form-title {
  display: block;
  font-size: 30px;
  color: #333333;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 30px;
}
.login100-form-title i {
  font-size: 60px;
}

.wrap-input100 {
  width: 100%;
  position: relative;
  margin-bottom: 20px;
}

</style>
